module.exports = __webpack_public_path__ + "img/bg-shipment-booked.55eb92e9.svg";